import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const CustomErrorMessage = ({ name }) => {
  const { formState: { errors } } = useFormContext();

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => (
        <div className="p-invalid text-danger" style={{ color: 'red' }}>
          {message}
        </div>
      )}
    />
  );
};

export default CustomErrorMessage;
